export enum FeatureFlags {
  CLOUD_DESTINATION = "cloud-destination",
  PAYMENT_TRUST_SIGNALS = "payment-trust-signals",
  SSH_HELP = "ssh-help",
  PRICE_COMPARISON = "price-comparison",
  HARDWARE_TAGS = "hardware-tags",
  MAP_DOCS_TO_PRODUCTS = "map-docs-to-products"
}

export const FEATURE_FLAGS = {
  [FeatureFlags.CLOUD_DESTINATION]: "cloud-destination",
  [FeatureFlags.PAYMENT_TRUST_SIGNALS]: "payment-trust-signals",
  [FeatureFlags.SSH_HELP]: "ssh-help",
  [FeatureFlags.PRICE_COMPARISON]: "price-comparison",
  [FeatureFlags.HARDWARE_TAGS]: "hardware-tags",
  [FeatureFlags.MAP_DOCS_TO_PRODUCTS]: "map-docs-to-products"
};
